import { Button, CardContent, Grid, TextField, Typography, Divider, Autocomplete, Modal, Box, Select, MenuItem } from '@mui/material';
import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import HOST_URL from '../../../utils/Url';
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import nopdf from '../../../assets/images/nopdf.png'
import dayjs, { Dayjs } from "dayjs";

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "180vh",
    height: "85vh",
    bgcolor: "#f5f5f5",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
};


type Props = {};

const DocFilesEdit = (props: Props) => {

    const location = useLocation();
    console.log('location', location.state)


    const { t } = useTranslation();


    const [DocOption, setDocOption] = useState<any>([
        { value: "-1", label: t("text.SelectDoc") },
    ]);

    const [LocateOption, setLocateOption] = useState<any>([
        { value: "-1", label: t("text.SelectLocation") },
    ]);



    useEffect(() => {
        getDocMid();
        getLocate();
        getimgbyid();


    }, [])

    const getDocMid = () => {
        const collectData = {
            docMid: -1,
            fileTypId: -1,
            divisionid: -1,
            subsubjId: -1,
            user_Id: -1,
            fileNo: ""
        };
        axios
            .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileNo,
                    value: item.docMid,
                }));
                setDocOption(arr);
            });
    };

    const getLocate = () => {
        const collectData = {
            id: -1,
            nodeID: -1,
            titleID: -1
        };
        axios
            .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.name,
                    value: item.id,
                }));
                setLocateOption(arr);
            });
    };

    const getimgbyid = () => {
        const collectData = {
            pdFid: location.state.pdFid,
            user_id: location.state.user_id,

        };

        axios
            .post(HOST_URL.HOST_URL2 + `DocFiles/GetDocFiles`, collectData)
            .then((res) => {
                console.log("result" + JSON.stringify(res.data.data[0]["pdfPath"]));

                const Doc = res.data.data[0]["pdfPath"];
                formik.setFieldValue("pdfPath", Doc);
            });
    };


    const [panOpens, setPanOpen] = React.useState(false);
    const [modalImg, setModalImg] = useState("");
    const handlePanClose = () => {
        setPanOpen(false);
    };
    const modalOpenHandle = (event: any) => {
        setPanOpen(true);
        if (event === "pdfPath") {
            setModalImg(formik.values.pdfPath);
        }
    };
    const ConvertBase64 = (file: Blob) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };
    // const otherDocChangeHandler = async (event: any, params: any) => {
    //   if (event.target.files && event.target.files[0]) {
    //     const file = event.target.files[0];
    //     const base64 = await ConvertBase64(file);
    //     formik.setFieldValue(params, base64);
    //   }
    // }

    const otherDocChangeHandler = async (event: any, params: any) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const fileNameParts = file.name.split(".");
            const fileExtension = fileNameParts[fileNameParts.length - 1];
            if (fileExtension.toLowerCase() === "pdf") {
                const base64 = await ConvertBase64(file);
                formik.setFieldValue(params, base64);
                console.log(base64);
            } else {
                // Display an error message indicating that only PDF files are allowed
                alert("Only PDF files are allowed to be uploaded.");
                // Optionally, you can clear the file input field
                event.target.value = null;
            }
        }
    };



    let navigate = useNavigate();
    

    const back = useNavigate();

    const requiredFields = ['pdfName'];

    const validationSchema = Yup.object({
        pdfName: Yup.string().test(
            'required',

            function (value: any) {
                return value && value.trim() !== '';
            }
        ),
    });

    const formik = useFormik({
        initialValues: {
            pdFid: location.state.pdFid,
            pdfName: location.state.pdfName,
            docMid: location.state.docMid,
            keywords: location.state.keywords,
            subFtype: location.state.subFtype,
            pDate: dayjs(location.state.pDate).format("YYYY-MM-DD"),
            locatId: location.state.locatId,
            isMain: location.state.isMain,
            entryDate: location.state.entryDate,
            pdfPath: location.state.pdfPath,
            pdfPathbyte: location.state.pdfPathbyte,
            user_id: location.state.user_id,

        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {

            const response = await axios.post(
                HOST_URL.HOST_URL2 + `DocFiles/AddUpdateDocFiles`,
                values
            );
            try {
                alert(response.data.mesg);
                navigate('/DocManagement/DocFiles');
            } catch (error) {
                alert(response.data.mesg);
            }
        },
    });


    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    marginTop: "5px",
                    border: ".5px solid #FF7722",
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        textAlign="center"
                        style={{ fontSize: "18px", fontWeight: 500 }}
                    >
                        {t("text.EditDocFiles")}
                    </Typography>

                    <Grid item sm={4} xs={12}>
                        <Typography style={{ marginTop: "-75px" }}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    marginBottom: 15,
                                    marginTop: "45px",
                                    backgroundColor:`var(--header-background)`,
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Typography>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        <Grid item xs={12} container spacing={2}>

                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={DocOption}
                                    value={
                                        DocOption.find(
                                            (option: any) => option.value === formik.values.docMid
                                        ) || null
                                    }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);

                                        formik.setFieldValue("docMid", newValue?.value);

                                        formik.setFieldTouched("docMid", true);
                                        formik.setFieldTouched("docMid", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label={
                                            <span>
                                                {t("text.SelectDoc")} {""}
                                                {requiredFields.includes('docMid') && (
                                                    <span style={{ color: formik.values.docMid ? 'green' : 'red' }}>*</span>
                                                )}
                                            </span>
                                        } />
                                    )}
                                />

                                {formik.touched.docMid && formik.errors.docMid ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {String(formik.errors.docMid)}
                                    </div>
                                ) : null}
                            </Grid>




                            <Grid md={4} item>
                                <TextField
                                    label={
                                        <span>
                                            {t("text.EnterPdfName")} {requiredFields.includes('pdfName') && (
                                                <span style={{ color: formik.values.pdfName ? 'green' : 'red' }}>*</span>
                                            )}
                                        </span>
                                    }
                                    value={formik.values.pdfName}
                                    placeholder={t("text.EnterPdfName")}
                                    size="small"
                                    fullWidth
                                    name="pdfName"
                                    id="pdfName"
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.pdfName && formik.errors.pdfName ? (
                                    <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.pdfName)}</div>
                                ) : null}
                            </Grid>

                            <Grid md={4} item>
                                <TextField
                                    label={t("text.EnterKeywords")}
                                    value={formik.values.keywords}
                                    placeholder={t("text.EnterKeywords")}
                                    size="small"
                                    fullWidth
                                    name="keywords"
                                    id="keywords"
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid md={4} item>
                                <TextField
                                    label={t("text.EnterSubFtype")}
                                    value={formik.values.subFtype}
                                    name="subFtype"
                                    id="subFtype"
                                    placeholder={t("text.EnterSubFtype")}
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid md={4} item>
                                <TextField
                                    label={t("text.EnterPdfDate")}
                                    value={formik.values.pDate}
                                    placeholder={t("text.EnterPdfDate")}
                                    size="small"
                                    fullWidth
                                    name="pDate"
                                    id="pDate"
                                    type="date"
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>






                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={LocateOption}
                                    value={
                                        LocateOption.find(
                                            (option: any) => option.value === formik.values.locatId
                                        ) || null
                                    }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);

                                        formik.setFieldValue("locatId", newValue?.value);

                                        formik.setFieldTouched("locatId", true);
                                        formik.setFieldTouched("locatId", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label={
                                            <span>
                                                 {t("text.SelectLocation")} {""}
                                                {requiredFields.includes('locatId') && (
                                                    <span style={{ color: formik.values.locatId ? 'green' : 'red' }}>*</span>
                                                )}
                                            </span>
                                        } />
                                    )}
                                />

                                {formik.touched.locatId && formik.errors.locatId ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {String(formik.errors.locatId)}
                                    </div>
                                ) : null}
                            </Grid>

                            <Grid container spacing={1} item>
                                <Grid
                                    xs={12}
                                    md={4}
                                    sm={4}
                                    item
                                    style={{ marginBottom: "30px", marginTop: "30px" }}
                                >
                                    <TextField
                                        type="file"
                                        inputProps={{ accept: "application/pdf" }}
                                        InputLabelProps={{ shrink: true }}
                                        label={
                                            <strong style={{ color: "#000" }}>
                                                {t("text.AttachedFile")}
                                            </strong>
                                        }

                                        size="small"
                                        fullWidth
                                        style={{ backgroundColor: "white" }}
                                        onChange={(e) => otherDocChangeHandler(e, "pdfPath")}
                                    />
                                </Grid>
                                <Grid xs={12} md={4} sm={4} item></Grid>



                                <Grid xs={12} md={4} sm={4} item>
                                    <Grid
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-around",
                                            alignItems: "center",
                                            margin: "10px",
                                        }}
                                    >
                                        {formik.values.pdfPath == "" ? (
                                            <img
                                                src={nopdf}
                                                style={{
                                                    width: 150,
                                                    height: 100,
                                                    border: "1px solid grey",
                                                    borderRadius: 10,
                                                }}
                                            />
                                        ) : (
                                            <embed
                                                //alt="preview image"

                                                src={formik.values.pdfPath}
                                                style={{
                                                    width: 150,
                                                    height: 100,
                                                    border: "1px solid grey",
                                                    borderRadius: 10,
                                                    padding: "2px",
                                                }}
                                            />
                                        )}
                                        <Typography
                                            onClick={() => modalOpenHandle("pdfPath")}
                                            style={{
                                                textDecorationColor: "blue",
                                                textDecorationLine: "underline",
                                                color: "blue",
                                                fontSize: "15px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {t("text.Preview")}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Modal open={panOpens} onClose={handlePanClose}>
                                    <Box sx={style}>
                                        {modalImg == "" ? (
                                            <img
                                                src={nopdf}
                                                style={{
                                                    width: "170vh",
                                                    height: "75vh",
                                                }}
                                            />
                                        ) : (
                                            <embed
                                                // alt="preview image"
                                                src={modalImg}
                                                style={{
                                                    width: "170vh",
                                                    height: "75vh",
                                                    borderRadius: 10,
                                                }}
                                            />
                                        )}
                                    </Box>
                                </Modal>
                            </Grid>


                            <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        style={{
                                            backgroundColor:`var(--header-background)`,
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t("text.update")}
                                    </Button>
                                </Grid>

                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="reset"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#F43F5E",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                        onClick={(e) => formik.resetForm()}
                                    >
                                        {t("text.reset")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* </Card> */}
                    </form>
                </CardContent>
            </div>
        </div>
    );
};

export default DocFilesEdit;
